import React from 'react';

const decode = encoded => {
  if (typeof window === 'undefined' || !encoded) return '';
  try {
    return window.atob(encoded);
  } catch (e) {
    return '';
  }
};

const MailtoLink = ({
  encoded,
  className,
  children,
  subject,
  ...rest
}) => {
  const handleClick = e => {
    e.preventDefault();
    const addr = decode(encoded);
    if (!addr) return;
    const qs = subject ? `?subject=${encodeURIComponent(subject)}` : '';
    window.location.href = `mailto:${addr}${qs}`;
  };

  return (
    <a
      href="#contact"
      onClick={handleClick}
      className={className}
      rel="nofollow noopener"
      {...rest}
    >
      {children}
    </a>
  );
};

export default MailtoLink;
